import './LeadsController.scss'

export class LeadsController {

    static instance = [LeadsController];

    static template = require('./LeadsController.html')



}